import type { components } from '@/types/api.generated';

type SalesBridge = components['schemas']['SalesBridge'];
export type SalesBridgeProduct = SalesBridge['products'][number];

/** Tracked products whose stock is exactly zero. No menu gating: the card keeps its own rules. */
export function soldOutProducts(bridge: SalesBridge): SalesBridgeProduct[] {
  return bridge.products.filter(
    (product) => product.inventory?.tracked === true && product.inventory.quantity === 0,
  );
}

/**
 * The sold-out list the board cell and the pre-dispatch checks may show:
 * `null` (say nothing) while the read has not answered or when the Shopify
 * menu is unavailable, `soldOutProducts` otherwise.
 */
export function shownSoldOut(bridge: SalesBridge | undefined): SalesBridgeProduct[] | null {
  if (bridge === undefined) return null;
  if (bridge.shopify_menu?.unavailable_reason?.trim()) return null;
  return soldOutProducts(bridge);
}
